import React, { Component } from 'react';
import { shape, number, string, func, bool, oneOfType } from 'prop-types';
import cx from 'classnames';
import styles from './styles.scss';
import { AD_VISITS_OPTION, NEW_AD_USERS } from '../constants';

export default class StationTableRow extends Component {
  static propTypes = {
    data: shape({
      title: string,
      stationId: oneOfType([string, number]),
      avgAdCost: number,
      ads: number,
      adUser: number,
      adVisit: number,
      newAdUsers: number,
      newAdUsersOfAds: number,
      visitOfAds: number
    }),
    onCellClick: func,
    isAvgCostDisabled: bool,
    isCustomReport: bool,
    isShowNewAdUsers: bool,
  };

  static defaultProps = {
    data: {}
  };

  render() {
    const { data, onCellClick, isAvgCostDisabled, isCustomReport, isShowNewAdUsers } = this.props;
    const { title, ads, adVisit, visitOfAds, avgAdCost, newAdUsersOfAds, newAdUsers } = data;
    const formattedAdVisit = parseFloat(adVisit.toFixed(1));
    const localeAvgAdCost = avgAdCost == null ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;

    return (
      <div data-test="stationTableRow" className={styles.tableRow}>
        <div data-test="stationTableName" className={tableCellClasses} onClick={onCellClick({ data, key: 'title' })}>{title}</div>
        {isShowNewAdUsers ? (
          <div
            data-test="stationTableNewAdUsers"
            className={tableCellClasses}
            onClick={onCellClick({ data, key: NEW_AD_USERS })}
          >
            {parseFloat(newAdUsers.toFixed(1)).toLocaleString()}
          </div>
        ) : (
          <div
            data-test="stationTableAdVisits"
            className={tableCellClasses}
            onClick={onCellClick({ data, key: AD_VISITS_OPTION })}
          >
            {formattedAdVisit.toLocaleString()}
          </div>
        )}
        {/* <div className={styles.tableCell} onClick={onCellClick({data, key: 'adUser'})}>{adUser.toLocaleString()}</div> */}
        <div data-test="stationTableAds" className={tableCellClasses} onClick={onCellClick({ data, key: 'ads' })}>{ads.toLocaleString()}</div>
        {isShowNewAdUsers ? (
          <div
            data-test="stationTableNewAdUsersOfAds"
            className={tableCellClasses}
            onClick={onCellClick({ data, key: 'newAdUsersOfAds' })}
          >
            {parseFloat(newAdUsersOfAds.toFixed(2)).toLocaleString()}
          </div>
        ) : (
          <div
            data-test="stationTableAdvisitsAds"
            className={tableCellClasses}
            onClick={onCellClick({ data, key: 'visitOfAds' })}
          >
            {parseFloat(visitOfAds.toFixed(2)).toLocaleString()}
          </div>
        )}
        {
          !isAvgCostDisabled &&
          <div data-test="stationTableAvgAdCost" className={tableCellClasses} onClick={onCellClick({ data, key: 'avgAdCost' })}>{localeAvgAdCost}</div>
        }
      </div>
    );
  }
}
